import { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import Modal from './../Modal/Modal'
import './Alert.scss'

interface IAlertProps extends WithTranslation {
  onClose: () => void
  visible: boolean
  title: string
  message: string
}

class Alert extends Component<IAlertProps> {
  render() {
    const { title, message, onClose, t, visible } = this.props

    return (
      <Modal title={title} onClose={onClose} visible={visible} hideCloseBtn={true}>
        {/*<i className="alert-icon icon-info" />*/} {message}
        <div className="modal-bottom">
          <button title={t('OK')} onClick={onClose}>
            {t('OK')}
          </button>
        </div>
      </Modal>
    )
  }
}
// eslint-disable-next-line react-refresh/only-export-components
export default withTranslation('common')(Alert)
